module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("First, I’d like to thank the contributors for all their hard work and patience, which are clearly evident in these terrific essays. Many thanks are also due to Steve Wrinn and Anne Dean Watkins at the University Press of Kentucky, with whom it continues to be a real pleasure to work. Last, for all their love and support, I want to thank my family and friends, especially Pepper Landis, John and Linda Pappas, Aeon Skoble, and Jerry Williams.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d4ba72a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813172309_epub_ack_r1.vue
// module id = 72
// module chunks = 0